export interface UserInitialsInput {
  firstName?: string
  lastName?: string
  email?: string
}

const STARTS_WITH_LETTER = /^[a-zA-Z]/

function trimmed (value: string | undefined): string {
  return (value ?? '').trim()
}

export function getUserInitials (input: UserInitialsInput): string {
  const firstName = trimmed(input.firstName)
  const lastName = trimmed(input.lastName)
  const firstHasLetter = STARTS_WITH_LETTER.test(firstName)
  const lastHasLetter = STARTS_WITH_LETTER.test(lastName)

  if (firstHasLetter && lastHasLetter) {
    return (firstName[0] + lastName[0]).toUpperCase()
  }
  if (firstHasLetter) {
    return firstName[0].toUpperCase()
  }
  if (lastHasLetter) {
    return lastName[0].toUpperCase()
  }

  const email = trimmed(input.email)
  const localPart = email.split('@')[0] ?? ''
  if (!localPart) {
    return ''
  }

  const segments = localPart.split(/[._]/)
  if (
    segments.length >= 2 &&
    STARTS_WITH_LETTER.test(segments[0]) &&
    STARTS_WITH_LETTER.test(segments[1])
  ) {
    return (segments[0][0] + segments[1][0]).toUpperCase()
  }

  const cleaned = localPart.replace(/[^a-zA-Z0-9]/g, '')
  return cleaned.slice(0, 2).toUpperCase()
}
